// extracted by mini-css-extract-plugin
export default {"Checkbox":"📚19-10-2IDCi3"};